import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-consent',
  imports: [],
  templateUrl: './privacy-consent.html',
  styleUrl: './privacy-consent.css'
})
export class PrivacyConsentComponent {

}
